import { TrazabilidadAccionChoiceEnum, TipoEmpleadoEnumChoice } from '../constants';
import { Nullable } from '../interfaces';
import { ITrazabilidad } from '../interfaces/erp/global/trazabilidad.interface';

import { formatDateWithTime } from './format-date';

export const getTrazabilidad = (
  trazabilidadArr: ITrazabilidad[],
  targetUser: string,
  targetAction: string
): Nullable<ITrazabilidad> => {
  return (
    trazabilidadArr.find(
      trazo =>
        trazo.tipo_empleado === targetUser && trazo.accion === targetAction
    ) || null
  );
};

export const calcTrazavilidad = (
  trazabilidadArr: ITrazabilidad[],
  targetUser: string,
  targetAction: string,
  targetField: keyof ITrazabilidad
): string | null => {
  const trazabilidad = getTrazabilidad(
    trazabilidadArr,
    targetUser,
    targetAction
  );
  if (!trazabilidad) return null;

  const fieldValue = trazabilidad[targetField];
  if (!fieldValue) return null;

  if (
    targetField === 'fecha_creacion' ||
    targetField === 'fecha_modificacion'
  ) {
    return formatDateWithTime(fieldValue as any);
  }

  return fieldValue as any;
};

///* -------------
export const calcTrazavilidadVendedor = (
  trazabilidadArr: ITrazabilidad[],
  targetAction: string,
  targetField: 'user' | 'fecha_creacion' | 'fecha_modificacion'
): string | null => {
  return calcTrazavilidad(
    trazabilidadArr,
    TipoEmpleadoEnumChoice.VENDEDOR,
    targetAction,
    targetField
  );
};

export const calcTrazavilidadToString = (
  trazabilidadArr: ITrazabilidad[],
  targetAction: TrazabilidadAccionChoiceEnum
): string => {
  if (trazabilidadArr == null || trazabilidadArr.length === 0) return 'N/A';
  const resp = trazabilidadArr.filter(e => e.accion == targetAction).at(0)?.user;
  if (resp) return resp;
  return 'N/A';
}